import React, { useEffect, useState, useRef } from "react";
import Header from "../layout/Header";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import Swal from "sweetalert2";
import { getAddresses } from "../../actions/payment/getAddresses";
import PhoneInput from "react-phone-input-2";
import { getCitiesByDistrictName } from "../../actions/payment/getCitiesByDistrictName";
import { addAddress, resetAddAddress } from "../../actions/payment/addAddress";
import { checkout, resetCheckout } from "../../actions/payment/checkout";
import { getBasket } from "../../actions/payment/getBasket";
import { addBasket } from "../../actions/payment/addBasket";
import { updateApplicationStatus } from "../../actions/application/updateApplicationStatus";
import { trigerApplication } from "../../actions/application/trigerApplicationStatus";
import { formatCardNumber } from "../../helpers/formatter";
import { Link } from "react-router-dom";
import { getMSS } from "../../actions/agreement/getMSS";
import { signMSS } from "../../actions/agreement/signMSS"
import { removeAddress, resetRemoveAddress } from "../../actions/payment/removeAddress"
import { getApplication } from "../../actions/application/getApplication"
import SearchableDropdown from "../helperscomponents/SearchableDropdown";
import { getDistrict } from "../../actions/payment/getDistrict";

function Payment(props) {
  function validateCardNumber(number) {
    // Kart numarasının doğru formatta olduğunu kontrol et
    return number.length === 16; // Basit bir örnek
  }

  function validateExpiryDate(date) {
    // Son kullanma tarihinin doğru formatta olduğunu kontrol et
    return /(?:0[1-9]|1[0-2])\/[0-9]{2}/.test(date); // "MM/YY" formatı
  }

  function validateCVV(cvv) {
    // CVV'nin doğru formatta olduğunu kontrol et
    return cvv.length === 3; // Basit bir örnek
  }

  const { Id } = useParams();

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [district, setDistrict] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [addressLine4, setAddressLine4] = useState("");
  const [postCode, setPostCode] = useState("");
  const [locality, setLocality] = useState("");
  const [mail, setEmail] = useState("");
  const [nameSurname, setNameSurname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cvv, setCvv] = useState("");
  const location = useLocation();
  const [approve, setApprove] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get("status");
  const [mss, setMss] = useState("");
  const [modalType, setModalType] = useState("add");



  useEffect(() => {

    var jsonDatas = {
      "applicationId": Id,
    }
    var jsondata = JSON.stringify(jsonDatas)
    dispatch(addBasket(null, 0, 1, jsondata, "second-opinion", true, true));

  }, [dispatch])



  useEffect(() => {
    if (props.addBasket.done) {
      dispatch(getBasket());
    }
  }, [props.addBasket]);



  useEffect(() => {
    if (status == "success") {
      dispatch(trigerApplication(Id));
      dispatch(resetCheckout());
      return
    }
    if (status == "failed") {
      Swal.fire({
        icon: "error",
        title: "Ödeme işlemi başarısız",
        text: "Ödeme işlemi başarısız. Lütfen tekrar deneyiniz.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
      });
      return
    }
  }, [status]);




  useEffect(() => {
    if (props.trigerApplicationStatus.done) {
      dispatch(updateApplicationStatus(Id, 1));
      navigate("/applications");
    }
    if (props.trigerApplicationStatus.error != false) {
      Swal.fire({
        icon: "error",
        title: "Bir hata oluştu",
        text: "Bir hata oluştu. Lütfen tekrar deneyiniz.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
      });
    }
  }, [props.trigerApplicationStatus]);




  useEffect(() => {
    if (props.getMSS.done) {
      setMss(props.getMSS.getMSS.data.article.content);
    }
  }, [props.getMSS]);

  if (props.getApplication.done) {

    var surveyData = JSON.parse(
      props.getApplication?.getApplication?.survey?.data
    );
    var userNameSurname =
      props.getApplication?.getApplication?.applicationOwnerUser?.name +
      " " +
      props.getApplication?.getApplication?.applicationOwnerUser?.lastName;
    var professionName = surveyData["Görüş Almak İstediğiniz Uzmanlık Alanı"];
    var doctorNameSurname =
      props.getApplication?.getApplication?.assignments[0]?.doctor?.name +
      " " +
      props.getApplication?.getApplication?.assignments[0]?.doctor?.lastName;
  }

  useEffect(() => {
    dispatch(getApplication(Id))
  }, [dispatch])


  useEffect(() => {
    dispatch(getAddresses());
  }, [dispatch])



  useEffect(() => {
    if (props.addAddress.done) {
      Swal.fire({
        icon: "success",
        title: "İşlem başarılı",
        text: "Adres ekleme işlemi başarılı.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
      });
      dispatch(resetAddAddress());
      dispatch(getAddresses());
      return;
    }
  }, [props.addAddress]);


  function HandleSetAddress() {
    let address = {
      isValid: true,
      isCompany: false,
      email: mail,
      contactName: nameSurname,
      phone1: phoneNumber,
      ssn: "",
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      addressLine4: addressLine4,
      phone1Code: "+90",
      postCode: postCode,
      locality: locality,
      district: district,
    };
    dispatch(addAddress(address, true, 2));
  }

  var paymentInfo = {
    cardNumber: cardNumber,
    cardHolderName: nameSurname,
    exprMonth: expiryDate.slice(0, 2),
    exprYear: 20 + expiryDate.slice(-2),
    cv2: cvv,
  };

  const baseDomain = window.location.origin;

  var successAction = {
    actionType: 1,
    parameters: {
      url: `${baseDomain}/payment/${Id}?status=success`,
    },
  };
  var failAction = {
    actionType: 1,
    parameters: {
      url: `${baseDomain}/payment/${Id}?status=failed`,
    },
  };




  function HandlePayment() {

    if (props.getAddresses?.getAddresses?.data?.addresses?.length == 0) {
      Swal.fire({
        title: "Eksik adres bilgisi.",
        text: "Lütfen geçerli bir adres bilgisi ekleyiniz!",
        icon: "warning",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Anladım"
      }).then((result) => {
        if (result.isConfirmed) {
          document.getElementById("entas").click();
        }
      });
      return;
    }

    if (!approve) {
      Swal.fire({
        icon: "error",
        title: "Lütfen sözleşmeyi okuyup onaylayınız",
        confirmButtonText: "Anladım",
      });
      return;
    }
    if (
      !validateCardNumber(cardNumber) ||
      !validateExpiryDate(expiryDate) ||
      !validateCVV(cvv)
    ) {
      // Uyarı mesajı göster
      Swal.fire({
        icon: "error",
        title: "Lütfen kart bilgilerini eksiksiz giriniz",
        confirmButtonText: "Anladım",
      });
      return; // Doğrulama başarısızsa, fonksiyonu sonlandır
    }
    dispatch(checkout(13, paymentInfo, successAction, failAction, Id));


  }

  useEffect(() => {
    if (props.checkout.done) {
      const openNewPageWithHtmlContent = (htmlContent) => {
        const newWindow = window.open("", "_blank");
        if (newWindow) {
          setTimeout(() => {
            newWindow.document.write(htmlContent);
            newWindow.document.close();
          }, 1000);
        }
      };
      openNewPageWithHtmlContent(
        props.checkout.checkout?.data?.paymentResult?.resultMessage
      );
    }

    if (props.checkout.code != "unknow_error") {
      Swal.fire({
        icon: "error",
        title: "Bir hata oluştu",
        text: "Bir hata oluştu. Lütfen tekrar deneyiniz.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
      });
    }

    if (props.checkout.error != false) {
      Swal.fire({
        icon: "error",
        title: "Bir hata oluştu",
        text: "Bir hata oluştu. Lütfen tekrar deneyiniz.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
      });
    }
  }, [props.checkout]);

  useEffect(() => {
    if (props.removeAddress.done) {
      Swal.fire({
        icon: "success",
        title: "İşlem başarılı",
        text: "Adres silme işlemi başarılı.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>',
      });
      dispatch(getAddresses());
      dispatch(resetRemoveAddress());
    }

  }, [props.removeAddress])




  return (
    <div>
      <Header />
      <div className="pt-10 md:ml-64 ps-5">
        <ol
          className="flex items-center whitespace-nowrap min-w-0"
          aria-label="Breadcrumb"
        >
          <li className="text-sm">
            <a
              className="flex items-center text-gray-500 hover:text-blue-600"
              href="/select-facility"
            >
              Yeni Başvuru
              <svg
                className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </a>
          </li>
          <li className="text-sm">
            <a
              className="flex items-center text-gray-500 hover:text-blue-600"
              href="#"
            >
              Talep Formu
              <svg
                className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </a>
          </li>
          <li className="text-sm">
            <Link
              className="flex items-center text-gray-500 hover:text-blue-600"
              to={'/file-upload/' + Id}
            >
              Dosya Yükleme
              <svg
                className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </Link>
          </li>
          <li className="text-sm">
            <Link
              className="flex items-center text-gray-500 hover:text-blue-600"
              to={'/select-doctor/' + Id}
            >
              Hekim Belirle
              <svg
                className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </Link>
          </li>
          <li
            className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200"
            aria-current="page"
          >
            Ödeme
          </li>
        </ol>
      </div>
      <hr className="divide-y mt-2" />
      <h1 className="text-2xl font-semibold text-start mt-5 ps-5 md:ml-64">
        Ödemeyi Tamamla
        <div
          className="bg-yellow-50 mt-4 me-4 border border-yellow-200 text-sm text-yellow-800 rounded-lg p-4 dark:bg-yellow-800/10 dark:border-yellow-900 dark:text-yellow-500"
          role="alert"
        >
          <div className="flex">
            <div className="flex-shrink-0">
              <svg
                className="flex-shrink-0 h-4 w-4 mt-0.5"
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
                <path d="M12 9v4" />
                <path d="M12 17h.01" />
              </svg>
            </div>
            <div className="ms-4">
              <h3 className="text-sm font-semibold">
                Ödeme işlemi tamamlandıktan sonra dosya yüklemesi
                yapılamamaktadır.
              </h3>
              <div className="mt-1 text-sm text-yellow-700">
                Eklemek istediğiniz dosya varsa başvurularım alanından
                başvurunuzla alakalı dosyaları yükledikten sonra ödeme
                yapabilirsiniz.
              </div>
            </div>
          </div>
        </div>
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-5 ps-5 pe-5 md:ml-64">
        <div className="md:col-span-3">
          <div className="text-start">
            <label
              htmlFor="input-label1"
              className="block text-sm font-medium mb-2 dark:text-white"
            >
              İsim Soyisim
            </label>
            <input
              onChange={(e) => {
                setNameSurname(e.target.value);
              }}
              type="text"
              id="input-label1"
              className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
              placeholder="Banka/Kredi Kartı Üzerinde Bulunan İsim ve Soyisim"
            />
          </div>
          <div className="grid grid-cols-4 gap-4 text-start mt-5">
            <div className="col-span-2">
              <label
                htmlFor="hs-trailing-icon"
                className="block text-sm font-medium mb-2 dark:text-white"
              >
                Banka/Kredi Kartı Üzerinde 16 Haneli Numara
              </label>
              <div className="relative">
                <input
                  onChange={(e) => {
                    const formattedValue = formatCardNumber(e.target.value);
                    // Ekranda formatlanmış değeri göster
                    e.target.value = formattedValue;
                    // State'e formatlanmamış değeri kaydet
                    setCardNumber(formattedValue.replace(/-/g, ""));
                  }}
                  type="text"
                  id="hs-trailing-icon"
                  name="hs-trailing-icon"
                  className="py-3 px-4 pr-11 block w-full border-gray-200 shadow-sm rounded-md text-sm focus:z-10 focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="xxxx-xxxx-xxxx-xxxx"
                />
                <div className="absolute inset-y-0 right-0 flex items-center pointer-events-none z-20 pr-4">
                  <svg
                    className="h-4 w-4 text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1z" />
                    <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm13 2v5H1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm-1 9H2a1 1 0 0 1-1-1v-1h14v1a1 1 0 0 1-1 1z" />
                  </svg>
                </div>
              </div>
            </div>
            <div>
              <label
                htmlFor="dateInput"
                className="block text-sm font-medium mb-2 dark:text-white"
              >
                Son Kullanma Tarihi
              </label>
              <input
                onChange={(e) => {
                  let value = e.target.value;
                  value = value.replace(/[^0-9]/g, ""); // Sadece rakam olmasını sağlar
                  if (value.length > 2) {
                    value = value.substring(0, 2) + "/" + value.substring(2, 4);
                  }
                  e.target.value = value;
                  setExpiryDate(value);
                }}
                type="text"
                id="dateInput"
                className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                placeholder="AA/YY"
              />
            </div>
            <div>
              <label
                htmlFor="input-label3"
                className="block text-sm font-medium mb-2 dark:text-white"
              >
                CVV Numarası
              </label>
              <input
                onChange={(e) => {
                  setCvv(e.target.value);
                }}
                type="text"
                id="input-label3"
                className="py-3 px-4 mb-5 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                placeholder="CVV"
              />
            </div>
          </div>
          {props.checkout.spinner ? (
            <button
              type="button"
              style={{ backgroundColor: `#09C35C` }}
              className="mb-10 w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5"
            >
              <span
                className="animate-spin inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-white rounded-full"
                role="status"
                aria-label="loading"
              ></span>
              Tamamlanıyor...
            </button>
          ) : (
            <button
              onClick={HandlePayment}
              style={{ backgroundColor: `#09C35C` }}
              type="button"
              className="mb-10 w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5"
            >
              Ödemeyi Tamamla
            </button>
          )}
          <div className="flex mt-8">
            <input
              checked={approve}
              onClick={() => {
                dispatch(getMSS());
              }}
              onChange={() => {

              }}
              data-hs-overlay="#m234"
              type="checkbox"
              className="onedose-color shrink-0 mt-0.5 border-gray-200 rounded text-blue-600 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
              id="hs-default-checkbox1"
            />
            <label
              htmlFor="hs-default-checkbox1"
              className="text-sm text-gray-500 ml-3 dark:text-gray-400"
            >
              <a
                onClick={() => {
                  dispatch(getMSS());
                }}
                href="#" data-hs-overlay="#m234" className="onedose-color">
                Mesafeli satış sözleşmesi metnini
              </a>{" "}
              okudum, onayladım.
            </label>
          </div>

          <div id="m234" className="hs-overlay hidden w-full h-full fixed top-0 left-0 z-[60] overflow-x-hidden overflow-y-auto">
            <div
              className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all lg:max-w-4xl lg:w-full m-3 lg:mx-auto">
              <div
                className="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
                <div className="flex justify-between items-center py-3 px-4 border-b dark:border-gray-700">
                  <button type="button"
                    className="hs-dropdown-toggle inline-flex flex-shrink-0 justify-center items-center h-8 w-8 rounded-md text-gray-500 hover:text-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 focus:ring-offset-white transition-all text-sm dark:focus:ring-gray-700 dark:focus:ring-offset-gray-800"
                    data-hs-overlay="#hs-large-modal">
                    <span className="sr-only">Close</span>
                    <svg className="w-3.5 h-3.5" width="8" height="8" viewBox="0 0 8 8" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.258206 1.00652C0.351976 0.912791 0.479126 0.860131 0.611706 0.860131C0.744296 0.860131 0.871447 0.912791 0.965207 1.00652L3.61171 3.65302L6.25822 1.00652C6.30432 0.958771 6.35952 0.920671 6.42052 0.894471C6.48152 0.868271 6.54712 0.854471 6.61352 0.853901C6.67992 0.853321 6.74572 0.865971 6.80722 0.891111C6.86862 0.916251 6.92442 0.953381 6.97142 1.00032C7.01832 1.04727 7.05552 1.1031 7.08062 1.16454C7.10572 1.22599 7.11842 1.29183 7.11782 1.35822C7.11722 1.42461 7.10342 1.49022 7.07722 1.55122C7.05102 1.61222 7.01292 1.6674 6.96522 1.71352L4.31871 4.36002L6.96522 7.00648C7.05632 7.10078 7.10672 7.22708 7.10552 7.35818C7.10442 7.48928 7.05182 7.61468 6.95912 7.70738C6.86642 7.80018 6.74102 7.85268 6.60992 7.85388C6.47882 7.85498 6.35252 7.80458 6.25822 7.71348L3.61171 5.06702L0.965207 7.71348C0.870907 7.80458 0.744606 7.85498 0.613506 7.85388C0.482406 7.85268 0.357007 7.80018 0.264297 7.70738C0.171597 7.61468 0.119017 7.48928 0.117877 7.35818C0.116737 7.22708 0.167126 7.10078 0.258206 7.00648L2.90471 4.36002L0.258206 1.71352C0.164476 1.61976 0.111816 1.4926 0.111816 1.36002C0.111816 1.22744 0.164476 1.10028 0.258206 1.00652Z"
                        fill="currentColor" />
                    </svg>
                  </button>
                </div>
                <div className="p-4 overflow-y-auto max-h-[800px]">
                  {props.getMSS.done ?
                    <div dangerouslySetInnerHTML={{ __html: props.getMSS.getMSS.data.article.content }} /> : null}
                </div>
                <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
                  <button type="button"
                    className="hs-dropdown-toggle py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm dark:bg-slate-900 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800"
                    data-hs-overlay="#m234">
                    Vazgeç
                  </button>
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(signMSS(null, "mesafeli-satis-sozlesmesi", true))
                      setApprove(true);
                    }}
                    style={{ backgroundColor: `#09C35C` }}
                    data-hs-overlay="#m234"
                    type="button"
                    className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent
          font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500
          focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800"
                    href="#"
                  >
                    Okudum Anladım
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div className="md:col-span-1">
          <div className="flex justify-between ps-5 me-5">
            <h4>Kayıtlı adresleriniz</h4>
            <button
              id="entas"
              onClick={() => {
                setNameSurname("");
                setEmail("");
                setPhoneNumber("");
                setAddressLine1("");
                setAddressLine2("");
                setDistrict("");
                setLocality("");
                setPostCode("");
              }}
              data-hs-overlay="#hs-slide-up-animation-modal"
              type="button"
              className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-500 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
            >
              <i className="fa-light fa-plus"></i>
            </button>
          </div>

          {props.getAddresses.done ? (
            props.getAddresses.getAddresses.data.addresses.length != 0 ? (
              props.getAddresses.getAddresses.data.addresses.map(
                (element, index) => {
                  return (
                    <div key={index} className="relative bg-slate-100 border rounded-md p-3 mt-5 text-start">
                      <div className="top-0 left-0 right-0">
                        <div className="grid space-y-3">
                          <div className="relative bg-slate-100 border rounded-md p-3 mt-5 ms-10 me-10 text-start">
                            <div className="absolute top-2 right-2 space-x-2">
                              <button
                                onClick={() => {
                                  document.getElementById("entas").click();
                                  setModalType("edit");
                                  setNameSurname(element.address.contactName);
                                  setEmail(element.address.email);
                                  setPhoneNumber(element.address.phone1);
                                  setAddressLine1(element.address.addressLine1);
                                  setAddressLine2(element.address.addressLine2);
                                  setDistrict(element.address.district);
                                  setLocality(element.address.locality);
                                  setPostCode(element.address.postCode);
                                }}
                                style={{ backgroundColor: `#09C35C` }}
                                type="button"
                                className="p-1 flex justify-center items-center text-sm font-semibold rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.207l-3 3L3 16.5l13.732-13.732z"></path></svg>
                              </button>
                              <button
                                onClick={(e) => {
                                  Swal.fire({
                                    title: "Emin misiniz?",
                                    text: "Kayıtlı adresiniz silinecektir!",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Sil",
                                    cancelButtonText: "Vazgeç",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      dispatch(removeAddress(element.addressId));
                                    }
                                  });
                                }}
                                style={{ backgroundColor: `#ff3c3c` }}
                                type="button"
                                className="p-1 flex justify-center items-center text-sm font-semibold rounded-lg border border-transparent bg-red-600 text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                              </button>
                            </div>
                            <div className="flex items-center h-5 mt-1">
                              <input
                                key={index}
                                id={`hs-radio-delete${index}`}
                                name="hs-radio-with-description"
                                type="radio"
                                className="border-gray-200 rounded-full text-blue-600 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                                aria-describedby="hs-radio-delete-description"
                                defaultChecked
                              />
                              <label htmlFor={`hs-radio-delete${index}`} className="ml-3">
                                <span className="block text-sm font-semibold text-gray-800 dark:text-gray-300">
                                  {element.address.locality}
                                </span>
                                <span id="hs-radio-delete-description" className="block text-sm text-gray-600 dark:text-gray-500">
                                  {element.address.addressLine1}
                                </span>
                              </label>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  );
                }
              )
            ) : (
              <div className="relative bg-slate-100 border rounded-sm mt-5 ms-10 me-10 text-start">
                <div className="top-0 left-0 right-0">
                  <div
                    className="bg-red-50 border border-red-200 rounded-md p-4"
                    role="alert"
                  >
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <svg
                          className="h-4 w-4 text-red-400 mt-0.5"
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                        </svg>
                      </div>
                      <div className="ml-4">
                        <h3 className="text-sm text-red-800 font-semibold">
                          Fatura adresiniz bulunmamaktadır
                        </h3>
                        <div className="mt-2 text-sm text-red-700">
                          <p>
                            Lütfen{" "}
                            <a
                              type="button"
                              className=""
                              href="#"
                              data-hs-overlay="#hs-slide-up-animation-modal"
                            >
                              <b>fatura adresi</b> ekleyiniz.
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          ) : null}

          <div className="relative bg-slate-100 border rounded-sm mt-5 text-start">
            <div className="top-0 left-0 right-0">
              <div className="p-4 md:p-5">
                <p className="mt-5 text-xs text-gray-500">Başvuru Sahibi</p>
                <p className="mt-1 text-gray-800">{userNameSurname}</p>
                <p className="mt-5 text-xs text-gray-500">
                  Görüş Alınan Uzmanlık Alanı
                </p>
                <p className="mt-1 text-gray-800">{professionName}</p>
                <p className="mt-5 text-xs text-gray-500">Görüş Alınan Hekim</p>
                <p className="mt-1 text-gray-800">{doctorNameSurname}</p>
                <p className="mt-5 text-xs text-gray-500">Başvuru Ücreti</p>
                <p className="mt-1 text-3xl onedose-color font-semibold">₺7.000</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="hs-slide-up-animation-modal"
        className="hs-overlay hidden w-full h-full fixed top-0 left-0 z-[60] overflow-x-hidden overflow-y-auto"
      >
        <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-14 opacity-0 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto">
          <div className="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
            <div className="flex justify-between items-center py-3 px-4 border-b dark:border-gray-700">
              <h3 className="font-bold text-gray-800 dark:text-white">
                {modalType === "add" ? "Adres Ekle" : "Adres Güncelle"}
              </h3>
              <button
                type="button"
                className="hs-dropup-toggle inline-flex flex-shrink-0 justify-center items-center h-8 w-8 rounded-md text-gray-500 hover:text-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 focus:ring-offset-white transition-all text-sm dark:focus:ring-gray-700 dark:focus:ring-offset-gray-800"
                data-hs-overlay="#hs-slide-up-animation-modal"
              >
                <span className="sr-only">Close</span>
                <svg
                  className="w-3.5 h-3.5"
                  width="{8}"
                  height="{8}"
                  viewBox="0 0 8 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.258206 1.00652C0.351976 0.912791 0.479126 0.860131 0.611706 0.860131C0.744296 0.860131 0.871447 0.912791 0.965207 1.00652L3.61171 3.65302L6.25822 1.00652C6.30432 0.958771 6.35952 0.920671 6.42052 0.894471C6.48152 0.868271 6.54712 0.854471 6.61352 0.853901C6.67992 0.853321 6.74572 0.865971 6.80722 0.891111C6.86862 0.916251 6.92442 0.953381 6.97142 1.00032C7.01832 1.04727 7.05552 1.1031 7.08062 1.16454C7.10572 1.22599 7.11842 1.29183 7.11782 1.35822C7.11722 1.42461 7.10342 1.49022 7.07722 1.55122C7.05102 1.61222 7.01292 1.6674 6.96522 1.71352L4.31871 4.36002L6.96522 7.00648C7.05632 7.10078 7.10672 7.22708 7.10552 7.35818C7.10442 7.48928 7.05182 7.61468 6.95912 7.70738C6.86642 7.80018 6.74102 7.85268 6.60992 7.85388C6.47882 7.85498 6.35252 7.80458 6.25822 7.71348L3.61171 5.06702L0.965207 7.71348C0.870907 7.80458 0.744606 7.85498 0.613506 7.85388C0.482406 7.85268 0.357007 7.80018 0.264297 7.70738C0.171597 7.61468 0.119017 7.48928 0.117877 7.35818C0.116737 7.22708 0.167126 7.10078 0.258206 7.00648L2.90471 4.36002L0.258206 1.71352C0.164476 1.61976 0.111816 1.4926 0.111816 1.36002C0.111816 1.22744 0.164476 1.10028 0.258206 1.00652Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </div>
            <div className="p-4 overflow-y-auto">
              <div className="text-start">
                <label
                  htmlFor="input-label1"
                  className="block text-sm font-medium mb-2 dark:text-white"
                >
                  İsim Soyisim
                </label>
                <input
                  onChange={(e) => {
                    setNameSurname(e.target.value);
                  }}
                  value={nameSurname}
                  type="text"
                  id="input-label1"
                  className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Lütfen isim soyisim bilgilerinizi giriniz"
                />
              </div>
              <div className="text-start mt-2">
                <label
                  htmlFor="input-label1"
                  className="block text-sm font-medium mb-2 dark:text-white"
                >
                  E-mail Adresi
                </label>
                <input
                  onChange={(e) => {
                    const value = e.target.value;
                    const turkishChars = /[çğıöşüÇĞİÖŞÜ]/; // Türkçe karakter kontrolü
                    if (!turkishChars.test(value)) {
                      setEmail(value); // Sadece geçerli değerleri günceller
                    } else {
                      alert("E-posta adresi Türkçe karakter içermemelidir!"); // Uyarı gösterebilirsiniz
                    }
                  }}
                  type="email"
                  value={mail}
                  id="input-label1"
                  className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Lütfen mail adresinizi giriniz"
                />
              </div>
              <div className="text-start mt-2">
                <label
                  htmlFor="input-label1"
                  className="block text-sm font-medium mb-2 dark:text-white"
                >
                  Telefon Numaranız
                </label>
                <PhoneInput
                  containerStyle={{ width: "100%" }}
                  id="phoneNumber"
                  className="py-1 block w-full border-gray-200 rounded-md text-sm border focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                  type="text"
                  placeholder="Telefon numaranız"
                  name="phoneNumber"
                  country={"tr"}
                  inputStyle={{
                    width: `100% important!`,
                    border: `0px`,
                    paddingLeft: `58px`,
                  }}
                  enableSearch={false}
                  required={true}
                  value={phoneNumber}
                  onChange={(e) => {
                    setPhoneNumber(e);
                  }}
                />
              </div>
              <div className="text-start mt-2">
                <label
                  htmlFor="sess"
                  className="block text-sm font-medium mb-2 dark:text-white"
                >
                  İl
                </label>
                <SearchableDropdown
                  placeholder="Şehir seç..."
                  onSelectionChange={(selectedCity) => {
                    setLocality(selectedCity.v);
                  }}
                  fetchDataFunction={getCitiesByDistrictName}
                  data={props.getCitiesByDistrictName?.getCitiesByDistrictName?.data?.matches || []}
                />
              </div>
              <div className="text-start mt-2">
                <label
                  htmlFor="input-label1"
                  className="block text-sm font-medium mb-2 dark:text-white"
                >
                  İlçe
                </label>
                <SearchableDropdown
                  placeholder="İlçe seç..."
                  onSelectionChange={(e) => {
                    setDistrict(e.v)
                  }}
                  fetchDataFunction={getDistrict}
                  data={props.getDistrict?.getDistrict?.data?.matches || []}
                />
              </div>

              <div className="text-start mt-2">
                <label
                  htmlFor="input-label1"
                  className="block text-sm font-medium mb-2 dark:text-white"
                >
                  Adres Detay
                </label>
                <input
                  onChange={(e) => {
                    setAddressLine1(e.target.value);
                  }}
                  type="text"
                  value={addressLine1}
                  id="input-label1"
                  className="mt-2 py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Lütfen adres bilgisini giriniz"
                />
                <input
                  onChange={(e) => {
                    setAddressLine2(e.target.value);
                  }}
                  value={addressLine2}
                  type="text"
                  id="input-label1"
                  className="mt-2 py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Lütfen adres bilgisini giriniz"
                />
                <input
                  onChange={(e) => {
                    setAddressLine4(e.target.value);
                  }}
                  value={addressLine4}
                  type="text"
                  id="input-label1"
                  className="mt-2 py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Lütfen adres bilgisini giriniz"
                />
              </div>
              <div className="text-start mt-2">
                <label
                  htmlFor="input-label1"
                  className="block text-sm font-medium mb-2 dark:text-white"
                >
                  Posta kodu
                </label>
                <input
                  //   defaultValue={district}
                  onChange={(e) => {
                    setPostCode(e.target.value);
                  }}
                  value={postCode}
                  type="text"
                  id="input-label1"
                  className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Lütfen posta kodunu giriniz"
                />
              </div>
            </div>
            <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
              <button
                type="button"
                className="hs-dropup-toggle py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm dark:bg-slate-900 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800"
                data-hs-overlay="#hs-slide-up-animation-modal"
              >
                Vazgeç
              </button>
              {modalType === "add" ?
                <a
                  data-hs-overlay="#hs-slide-up-animation-modal"
                  onClick={HandleSetAddress}
                  className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800"
                  href="#"
                >
                  Adresi kaydet
                </a>
                :
                <a
                  data-hs-overlay="#hs-slide-up-animation-modal"
                  onClick={HandleSetAddress}
                  className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800"
                  href="#"
                >
                  Adresi Güncelle
                </a>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return state;
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(Payment);
